module.exports = __webpack_public_path__ + "assets/img/tongue-idle.6750352f.png";